/**
 * InfoCard Component
 * Карточка с иконкой, заголовком и описанием
 * @param {ReactNode} icon - Иконка (опционально)
 * @param {string} title - Заголовок карточки
 * @param {string} subtitle - Сабтайтл/метка (опционально)
 * @param {string|ReactNode} children - Содержимое/текст карточки
 * @param {string} className - Дополнительные CSS классы
 * @param {string} iconSize - Размер иконки (sm, md, lg, xl) - default: 'md'
 */
import React from 'react';

export default function InfoCard({
  icon,
  title,
  subtitle,
  children,
  className = '',
  iconSize = 'md',
}) {
  const iconSizeMap = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  };

  return (
    <div className={`p-6 rounded-2xl border border-slate-200 ${className}`}>
      {icon && (
        <div className={`${iconSizeMap[iconSize] || iconSizeMap.md} mb-3 text-brand-orange`}>
          {typeof icon === 'function' ? React.createElement(icon, { size: 32 }) : icon}
        </div>
      )}
      {subtitle && (
        <p className='text-blue-600 font-montserrat font-bold text-sm uppercase mb-2'>
          {subtitle}
        </p>
      )}
      {title && (
        <h3 className='font-montserrat font-bold text-lg mb-2 text-slate-900'>
          {title}
        </h3>
      )}
      <div className='text-slate-700'>
        {typeof children === 'string' ? (
          <p>{children}</p>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
